/**
 * Monsters runtime — re-exports the validated JSON data layer.
 * HP-resolved fields (currentHp, monsterHp) live on PlayerState via simulate().
 */
import type { ItemId } from '../state';
import { MONSTERS_DATA, MONSTERS_BY_ID } from '../../data';

export type MonsterTier = 1 | 2 | 3;
export type MonsterSpec = (typeof MONSTERS_DATA.monsters)[number];
export type { ItemId };

export const MONSTERS: ReadonlyArray<MonsterSpec> = MONSTERS_DATA.monsters;
export { MONSTERS_BY_ID };

export function getMonster(id: MonsterSpec['id']): MonsterSpec {
  const m = MONSTERS_BY_ID.get(id);
  if (!m) throw new Error(`Unknown monster: ${id}`);
  return m;
}